<template>

    <Head titulo="Directorio Turístico" />
    <div class="hero-imgs hero-imgs-encabezado">
        <div class="container">
            <div class="row align-items-md-center">
                <div class="col-md-6">
                    <h1 class="hero-imgs__encabezado">Directorio Turístico</h1>
                </div>
                <div class="col-md-6">
                    <div class="hero-imgs__img img-der">
                        <img loading="lazy" width="450" height="358" src="/img/hero-turismo-lugares-interes.png"
                            alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="contenido-wrapper">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="breadcrumb-block-wrapper">
                        <ul class="breadcrumb-block">
                            <li class="breadcrumb-block__item">
                                <a href="/turismo" class="breadcrumb-block__section">Turismo</a>
                            </li>
                            <li class="breadcrumb-block__item">
                                <a href="/turismo/directorio-turistico" class="breadcrumb-block__section">Directorio Turístico</a>
                            </li>
                            <li class="breadcrumb-block__item active">
                                <span class="breadcrumb-block__section">{{ categoria_nombre }}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="bloque-general bloque-tabs-directorio">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h3 class="encabezado-separador"><span>Directorio de {{ categoria_nombre }} en Santiago</span>
                        </h3>
                    </div>
                </div>
                <div class="row justify-content-lg-between">
                    <div class="col-md-5 col-lg-4">
                        <ul class="nav flex-column tabs-items-iconos mb-4">
                            <li v-for="(item, index) in categorias" :key="index">
                                <Link :href="'/turismo/directorio-turistico/' + item.slug"
                                    :class="{ active: categoria_id == item.id }">
                                <div class="tabs-items-iconos__img">
                                    <img loading="lazy" width="15" height="20" :src="'/storage/' + item.icono" alt="">
                                </div>
                                <span>{{ item.nombre }}</span>
                                </Link>
                            </li>
                        </ul>
                    </div>
                    <div class="col-md-7">
                        <div class="tab-content">

                            <div class="col-12">
                                <div class="bloque-filtro">
                                    <form action="#">
                                        <div class="form-group">
                                            <input class="input-buscador" v-model="search" type="text" :placeholder="'Buscar por Nombre en '+categoria_nombre">
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <div v-if="negocios.data.length < 1">
                                <NoResults/>
                            </div>
                            <a v-for="(item, index) in negocios.data" :key="index" class="item-directorio-lugar">
                                <div class="item-directorio-lugar__nombre">{{ item.nombre }}</div>
                                <div class="item-directorio-lugar__descripcion" v-if="item.informacion != ''">
                                    <p>{{ item.informacion }}</p>
                                </div>
                                <div class="item-directorio-lugar__direccion">
                                    <span><i class="fi fi-map"></i> Dirección</span>
                                    <p>{{ item.direccion }}</p>
                                </div>
                                <div class="item-directorio-lugar__info mb-2" v-if="item.tipo!=null">
                                    <span class="mr-1"><i class="fi fi-cocktail"></i> <b>Tipo de Comida: </b></span> {{ item.tipo }}
                                </div>
                                <div class="item-directorio-lugar__info">
                                    <div class="lugar-horario" v-if="item.horario!=null">
                                        <span><i class="fi fi-clock"></i> {{ item.horario }}</span>
                                    </div>
                                    <div class="lugar-telefono"><i class="fi fi-phone"></i> {{ item.telefono }}</div>
                                </div>
                                <div class="item-directorio-lugar__info mt-2">
                                    <div class="lugar-horario" v-if="item.facebook!=null"><a :href="item.facebook" target="_blank"><i class="fi fi-facebook"></i>Facebook</a></div>
                                    <div class="lugar-telefono" v-if="item.website!=null"><a :href="item.website" target="_blank"><i class="fi fi-link"></i>Página Web</a></div>
                                    <div class="lugar-telefono" v-if="item.link_mapa!=null"><a :href="item.link_mapa" target="_blank"><i class="fi fi-map-marker-alt"></i>Como llegar</a></div>
                                </div>
                            </a>
                        </div>
                        <div class="row" v-if="negocios.total > limit">
                            <div class="col-12">
                                <Paginacion :links="negocios.links" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Head from '../../Shared/Head.vue';
import { Link } from '@inertiajs/inertia-vue3';
import Paginacion from '../../Shared/Paginacion.vue';
import { Inertia } from '@inertiajs/inertia';
import debounce from 'lodash/debounce';
import NoResults from "../../Shared/Utils/NoResults.vue";

export default {
    props: {
        categorias: Object,
        negocios: Object,
        limit: Number,
        categoria_id: Number,
        categoria_nombre: String,
        categoria_slug: String,
        filters: Object,
    },
    data() {
        return {
            search: this.filters.search,
        }
    },
    created(){
        //this.search = this.filters.search;
    },
    components: {
        Head, Link, Paginacion, NoResults
    },
    watch: {

        search: debounce(function (value) {
            Inertia.get('/turismo/directorio-turistico/'+this.categoria_slug,
                {
                    search: value,
                },
                {
                    preserveState: true,
                    preserveScroll: true,
                    replace: true
                }
            )
        }, 500)
    },
}
</script>
<style scoped>
.fi {
    margin-right: 5px;
    color: #b0e2e3;
}

.lugar-telefono {
    align-items: center;
    padding-right: 10px;
}
.item-directorio-lugar__info a{
    color:#B29966;
}
</style>
